'use strict';

var breakpoints = require('../components/breakpoints');
var header = require('../components/header').collapsibleHeader;

module.exports = {
    // handles sticky scrolling behavior for static content page navigation
    navigation: function () {
        var $nav = $('#content-navigation-container .nav');

        if (!$nav.length) {
            return false;
        }

        var $header = $('header');
        var $pageTitle = $('h1');
        var $menu = $('#content-navigation-container');
        var $navContainer = $('#content-page-navigation');
        var headerBottom = $header.offset().top + header.getHeight();
        var menuBottom = $menu.offset().top + $menu.outerHeight();
        var pageTitleBottom = $pageTitle.offset().top + $pageTitle.outerHeight();
        var mediumUp = breakpoints.isDesktopView();
        var menuTrigger = mediumUp ? $nav.offset().top : $nav.offset().top + $nav.outerHeight();
        var scrollTriggerDelta = 50;

        if (menuTrigger <= headerBottom + 15 || menuTrigger <= document.documentElement.scrollTop) {
            $menu.addClass('sticky');
        }

        var setNavTop = function (top) {
            var $element = mediumUp ? $navContainer : $menu;
            $element.css({ top: top });
        };

        var lastScrollTop = 0;
        $(window).scroll(function () {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            var isScrollingDown = st > lastScrollTop;
            var navContainerBottom = $navContainer.offset().top + $navContainer.outerHeight();
            lastScrollTop = st <= 0 ? 0 : st;
            mediumUp = breakpoints.isDesktopView();
            menuTrigger = mediumUp ? $nav.offset().top : $menu.offset().top;
            headerBottom = $header.offset().top + header.getHeight();

            setNavTop(header.getHeight()); // set top equal to the header height

            if (isScrollingDown) {
                if (!$menu.hasClass('sticky') && !$navContainer.hasClass('bottom')) {
                    menuTrigger = mediumUp ? menuTrigger : $menu.offset().top + $menu.outerHeight();
                    // add sticky class when bottom of header reaches top of nav
                    if (menuTrigger <= headerBottom + mediumUp ? scrollTriggerDelta : 0) {
                        $nav.width(mediumUp ? $nav.outerWidth() : '');
                        $menu.addClass('sticky');
                    }
                } else if (navContainerBottom >= menuBottom) {
                    $navContainer.addClass('bottom');
                }
            } else {
                if ($navContainer.hasClass('bottom') && menuTrigger > headerBottom + mediumUp ? scrollTriggerDelta : 0) {
                    $navContainer.removeClass('bottom');
                }
                if (menuTrigger <= pageTitleBottom) {
                    // unstick nav when it has reached its original position (directly below page heading)
                    $menu.removeClass('sticky');
                    $menu.css({ top: 0 });
                }
            }
        });

        document.addEventListener('afterExpandHeader', function () {
            setNavTop(header.expandedHeight);
        });
        document.addEventListener('afterCollapseHeader', function () {
            setNavTop(header.getHeight());
        });

        return true;
    },

    // handles buttons toggle in Fit Guide page
    toggleButtons: function () {
        if ($('.content-page-navigation .content-page__body').hasClass('fit-guide') || $('.content-page-navigation .content-page__body').hasClass('size-chart')) {
            $('.fit-guide .fit-guide-btn').addClass('btn-secondary');
            $('.fit-guide .size-chart-btn').addClass('btn-primary');
            $('.size-chart .size-chart-btn').addClass('btn-secondary');
            $('.size-chart .fit-guide-btn').addClass('btn-primary');
        }

        $('.fit-guide .fit-guide-btn, .size-chart .size-chart-btn').click(function (e) {
            e.preventDefault();
        });
    }
};
